export default {
    buyAdditional: 'Buy additional MailPoints',
    description:
        'MailPoints allow you to send documents via Japan Post. The rate is 1 MailPoint per 5 pages, maximum 200 pages per order.',
    descriptionTitle: 'MailPoints',
    enterAmount: 'Enter an amount',
    manualInput: 'Manual Input',
    manualInputError: {
        max: 'Ensure this value is less than or equal to {{max}}.',
        min: 'Ensure this value is greater than or equal to {{min}}.',
    },
    pricePer: '{{price}} (+Tax) per MailPoint',
    proceed: ' Proceed to Checkout',
    selectAmount: 'Select an amount',
    submitButton: {
        error: 'Error',
        helperText:
            'Enter the amount of MailPoints to purchase ({{min}}-{{max}})',
        loading: 'Loading',
        plusTax: '{{value}} (+Tax)',
        submit: 'Proceed to Checkout',
    },
    tenMailpoints: '10 MailPoints',
    title: 'Purchase MailPoints - MakeLeaps',
    youCurrentlyHave: 'You currently have {{mailpoints}} MailPoints.',
};
